// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import cartPageStyles from "@pace/App/SharedStyles/CartPageStyles";
import { cartActionsStyles, CartPageViewType } from "@pace/Overrides/Widgets/Cart/CartActions";
import IconDefaultView from "@pace/XDL/Icons/IconDefaultView";
import IconList from "@pace/XDL/Icons/IconList";
import { createLinkIconStyles, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

cartActionsStyles.narrowHidden = {
    above: "sm",
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};
cartActionsStyles.wideHidden = {
    below: "md",
    css: css`
        display: flex;
        justify-content: flex-end;
    `,
};
cartActionsStyles.saveOrderButton = {
    buttonType: "outline",
    variant: "secondary",
};
cartActionsStyles.wideOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
        `,
    },
};
cartActionsStyles.wrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 32px;
        ${xScreen("lte", 1110)} {
            flex-direction: column;
            gap: 16px;
        }
        @media print {
            display: none;
        }
    `,
};
cartActionsStyles.saveOrderLink = {
    ...cartPageStyles.cartActions?.saveOrderLink,
};
cartActionsStyles.addAllToListClickable = {
    ...cartPageStyles.cartActions?.addAllToListClickable,
};
cartActionsStyles.removeAllLink = {
    ...cartPageStyles.cartActions?.removeAll,
};
cartActionsStyles.printLink = {
    ...cartPageStyles.cartActions?.printLink,
};
cartActionsStyles.leftSectionWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 32px;
        ${xScreen("lte", "md")} {
            gap: 24px;
        }
    `,
};
cartActionsStyles.rightSectionWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        justify-content: start;
        flex-grow: 1;
        ${xScreen("lte", 1110)} {
            justify-content: space-between;
            width: 100%;
        }
    `,
};
cartActionsStyles.saveAndAddToListWrapper = {
    css: css`
        display: flex;
        align-items: baseline;
        gap: 32px;
        ${xScreen("lte", "md")} {
            gap: 24px;
        }
    `,
};
cartActionsStyles.removeAndChangeViewWrapper = {
    css: css`
        flex: 1;
        display: flex;
        align-items: baseline;
        justify-content: end;
        gap: 82px;
    `,
};
cartActionsStyles.viewText = {
    size: 14,
    lineHeight: "22px",
    css: css`
        margin-right: 12px;
    `,
};
cartActionsStyles.changeViewWrapper = {
    css: css`
        display: flex;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
cartActionsStyles.defaultViewLink = {
    ...createLinkIconStyles(IconDefaultView, {
        icon: {
            iconProps: {
                size: 20,
                css: css`
                    & > svg {
                        height: 17px;
                    }
                `,
            },
        },
    }),
    css: css`
        margin-right: 8px;
        & > span {
            margin-left: 0;
            ${({ currentView }: any) =>
                currentView === CartPageViewType.defultView ? "opacity : 1" : "opacity : 0.5"};
        }
    `,
};
cartActionsStyles.condensedViewLink = {
    ...createLinkIconStyles(IconList, {
        icon: {
            iconProps: {
                size: 20,
                css: css`
                    & > svg {
                        height: 17px;
                    }
                `,
            },
        },
        css: css`
            & > span {
                ${({ currentView }: any) =>
                    currentView === CartPageViewType.condensedView ? "opacity : 1" : "opacity : 0.5"};
            }
        `,
    }),
};
cartActionsStyles.removeAllConfirmationModalStyles = {
    modal: {
        sizeVariant: "medium",
    },
};
